import { NgModule } from '@angular/core';
import { ClickOutDirective } from './clickOut.directive';
import { ContenteditableDirective } from './contenteditable.directive';
import { ImagePreloadDirective } from './image-preload.directive';
import { LoadingDirective } from './loading.directive';
import { LtDragDirective } from './lt-dag.directive';
import { InputRestrictDirective } from './input-restrict.directive';

const DIRECTIVES = [
    ClickOutDirective,
    LoadingDirective,
    ContenteditableDirective,
    ImagePreloadDirective,
    LtDragDirective,
    InputRestrictDirective
];

@NgModule({
    declarations: [...DIRECTIVES],
    exports: [...DIRECTIVES]
})
export class CiptechDirectivesModule { }
